// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__5t_il","rootNoMargin":"styles_rootNoMargin__3cp9v"};